import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSagas';
import { rootReducer } from './store/index';

declare global {
  interface Window { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any; }
}

declare const window: any;

const persistConfig = {
  key: 'za-hospital',
  storage,
  whitelist: ['inquiry', 'prescription', 'massageTherapy', 'service', 'clinic', 'medicine', 'physical'],
};

const __DEBUG__: boolean = process.env.NODE_ENV === 'development';

export default (() => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const composeEnhancers = (__DEBUG__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  }) : compose;
  const sagaMiddleware = createSagaMiddleware();
  const createStoreWithMiddleware = composeEnhancers(applyMiddleware(sagaMiddleware));
  const Store = createStore(persistedReducer, createStoreWithMiddleware);
  sagaMiddleware.run(rootSaga);
  window.globalStore = Store;
  const Persistor = persistStore(Store);
  return { Store, Persistor };
})();
